import { render, staticRenderFns } from "./MenuDisplayLocationsModal.vue?vue&type=template&id=63f23f98&scoped=true"
import script from "./MenuDisplayLocationsModal.vue?vue&type=script&lang=js"
export * from "./MenuDisplayLocationsModal.vue?vue&type=script&lang=js"
import style0 from "./MenuDisplayLocationsModal.vue?vue&type=style&index=0&id=63f23f98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f23f98",
  null
  
)

export default component.exports